import type { IconSvgObject } from './types';

const Edit02Icon: IconSvgObject = [
  ["path", { d: "M21.292 8.70711L7.99908 22H2V16L15.292 2.70715C15.6825 2.31661 16.3157 2.3166 16.7062 2.70713L21.292 7.29289C21.6825 7.68342 21.6825 8.31658 21.292 8.70711Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 6L18 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 22H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Edit02Icon;
